// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__iGe9GYi3","default":"secondaryButton_default__Xg2vs7yL","active":"secondaryButton_active__ZgwUO+5P"};